
/**
 * Initialise data structures required for modal form handling based on the data provided by the calling view
 *
 * @param formName    // The name of the form that requires a password check    (configured in blade view)
 */
window.confPassword = function(formName) {
    // verify password match
    document.forms[formName].onsubmit = function(event) {
        var inputPW     = document.getElementById('password').value;
        var inputPWC    = document.getElementById('password-confirmation').value;

        if (inputPW !== inputPWC) {
            //alert('{{ __("") }}');
            showSweetAlert('error', null, null, 'Passwords don’t match!')
            event.preventDefault();
        }
    };

    // verify if password is strong
    const password = document.getElementById('password');
    password.addEventListener('keyup', () => {
        let regexps = {
            'lowercase': /(?=.*[a-z])/,
            'uppercase': /(?=.*[A-Z])/,
            'digit': /(?=.*\d)/,
            'special': /(?=.*(_|[^\w]))/,
            'length': /^.{12,}$/
        }
        let val = password.value;
        Object.entries(regexps).forEach(([id, regex]) => {
            let constraint = document.getElementById(id);
            if (regex.test(val)) {
                constraint.classList.add("text-green-500", "font-bold");
            } else {
                constraint.classList.remove("text-green-500", "font-bold");
            }
        });
    })
}

window.togglePassword = function (toggleId, inputId) {
    const togglePassword = document.getElementById(toggleId);
    const password = document.getElementById(inputId);

    togglePassword.addEventListener('click', function (e) {
        // toggle the type attribute
        const type = password.getAttribute('type') === 'password' ? 'text' : 'password';
        password.setAttribute('type', type);
        // toggle the eye slash icon
        this.classList.toggle('ph-eye-slash');
    });
}
